module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_forum2.2f745.png";